import { datadogRum } from '@datadog/browser-rum'
import { APP_ENV, BACKEND_API_HOST } from './config'

export const initializeDatadog = () => {
  // ローカルではDatadogを初期化しない
  if (process.env.NODE_ENV !== 'production') return

  const clientToken = 'pubf0340fbcfa56bedfd8fabc4b18205098'

  datadogRum.init({
    applicationId: '4a646a0b-7e69-426c-b0fd-54efe9f17460',
    clientToken,
    site: 'datadoghq.com',
    service: 'toridori-marketing-web',
    env: APP_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 10,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    traceSampleRate: 100,
    traceContextInjection: 'sampled',
    allowedTracingUrls: [BACKEND_API_HOST],
  })
}
